import React, { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import cover from '../assets/cover.jpg';
import LiveChat from '../components/LiveChat';
import cover2 from '../assets/cpp.jpg';
import cover3 from '../assets/afloat.jpg';
import GetQuoteButton from '../components/GetQuoteButton';
import vision from "../assets/vision.png";
import mission from "../assets/mission.png";
import QAChatbot from '../components/QAChatBot';
import BackToTopButton from '../components/BackToTopButton';
import ScrollSocialIcons from '../components/ScrollSocialIcons';
import ceoImg from '../assets/ceo.webp';



import { motion } from 'framer-motion';

// Moved outside to avoid ESLint warning
const images = [cover, cover2, cover3];

const About = () => {
  const [currentSlide, setCurrentSlide] = useState(0);


  useEffect(() => {
    window.initAboutPage && window.initAboutPage();

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 3000); // Change image every 3 seconds

    return () => clearInterval(interval);
  }, []);

 

  return (
    <div>
      <Navbar />
      <div className="about-page">
        <div className="slideshow-wrapper-about">
          <img src={images[currentSlide]} alt="CIAP Legacy" className="cover-image" />
          <div className="dark-overlay"></div>
          <div className="cover-text">
            <h2>Our Legacy</h2>
          </div>
        </div>

        <section className="about-video-section">
          <div className="video-container-inline">
            <video 
              autoPlay 
              muted 
              loop 
              controls 
              className="about-company-video"
            >
              <source src="/videos/aboutus-video.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </section>

        <div className="vision-mission-container">
          <motion.section 
            className="vision-card" 
            id="vision"
            initial={{ opacity: 0, x: -100, scale: 0.9 }}
            whileInView={{ opacity: 1, x: 0, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          >
            <img src={vision} alt='Our Vision' />
          </motion.section>

          <motion.section 
            className="mission-card" 
            id="mission"
            initial={{ opacity: 0, x: 100, scale: 0.9 }}
            whileInView={{ opacity: 1, x: 0, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
          >
            <img src={mission} alt='mission' />
          </motion.section>
        </div>

        <section className="about-section" id="discover">
          <h2>Discover CIAP</h2>
          <p>
            Celebrating our <b>6<sup>th</sup> year</b> of Operation, we are capable of <b>Maintaining and Overhauling complete Propulsion Systems-Mechanical / Electrical, Major Equipment’s,
              Components & Accessories Providing Total Marine and Engineering Solutions.</b>
            <br />
            Our ambition to expand with branches in the UAE and our own shipyard Sri Lanka.
          </p>
        </section>

        <section className="about-section" id="values">
          <h2>Our Values</h2>
          <p>
            We provide <b>High-Quality Services</b>, <b>Encourage Innovation and Uphold Integrity</b>. Our focus on <b>Customers Feedback</b> enables us to provide <b>Outstanding Services & Solutions</b>.
          </p>
        </section>

        <section className="about-section" id="why">
          <h2>Why CIAP</h2>
          <p>
            Led by group of Marine Engineers, we Understand the importance of Mechanical and Electrical error / Faults and Able to Deploy Rider Teams Globally, who embark on vessels to carry out Repairs / Services as per the Scope. while the vessels is sailing maintaining seamless operations.
            Our motto — <b>“Serves with professionalism”.</b>
          </p>
        </section>

        <section className="about-section" id="history">
          <h2>Our History</h2>
          <p>
            Starting from modest origins, <b>CIAP</b> has developed into a reliable leader, marked by a history
            of accomplishments and a <b>Broadened range of Services</b>.
          </p>
        </section>

        <section className="about-section" id="hseq">
          <h2>HSEQ</h2>
          <p>
            We adhere to industry standards in <b>Health, Safety, Environment and Quality.</b> Our
            training guarantees Safety, Quality and Sustainability.
          </p>
        </section>

        <section className="about-section" id="professionalism">
          <h2>Professionalism in Everything We Do</h2>
          <p>
            “Project planning to execution to completion, Our expertise guides every effort and provides services that meet the<b> Highest Quality and Industry Standards</b>."
          </p>
        </section>

        {/* Founder & MD Section */}
        <section className="founder-section">
          <div className="founder-container">
            <div className="founder-content-wrapper">
              <motion.div 
                className="founder-image-box"
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8 }}
              >
                <img src={ceoImg} alt="T. A. Punsara Aravinda" className="founder-img" />
                <div className="founder-img-badge">
                  <span>16+ Years Experience</span>
                </div>
              </motion.div>
              
              <motion.div 
                className="founder-details"
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.8, delay: 0.2 }}
              >
                <span className="founder-subtitle">Visionary Leadership</span>
                <h2>T. A. Punsara Aravinda</h2>
                <h4 className="founder-role">Founder | Managing Director</h4>
                <p className="founder-creds">Marine Engineer | Consultant</p>
                
                <div className="founder-bio">
                  <p>
                    <strong>T. A. Punsara Aravinda</strong> is the Visionary Founder and Managing Director of CIAP (PVT) LTD, 
                    bringing together deep technical expertise, operational leadership, and strategic business acumen to 
                    drive sustained growth in the Marine and Engineering Sector.
                  </p>
                  <p>
                    A highly accomplished Marine Engineer holding a <strong>UK Class I (Motor) Certificate of Competency</strong>, 
                    he possesses extensive hands-on experience across diverse vessel operations, marine engineering systems, 
                    ship building and he carries vision towards developing of blue economy for country and regionally. 
                    His seagoing career (2007–2019) spans progressive leadership roles from 4th Engineer to Chief Engineer, 
                    providing comprehensive exposure to both Modern And Conventional Propulsion Systems, High And Low Power Machinery, 
                    Complex Shipboard Operations, Port Operations and Ship Building.
                  </p>
                  <p>
                    He further strengthens his professional foundation with an <strong>MBA from the University of Wolverhampton</strong>, 
                    a Diploma in Marine Engineering, and <strong>PQHRM certification</strong>, reflecting strong capabilities in strategic 
                    management, operational execution, and human capital leadership.
                  </p>
                  <p>
                    Beyond seagoing operations, he has contributed as an Operations Engineer in power plant operations and as a 
                    Visiting Lecturer at several universities, actively mentoring and developing the next generation of marine professionals.
                  </p>
                  <p>
                    Under his Leadership, CIAP (PVT) LTD has grown into a trusted provider of Marine Engineering, Ship Repair, 
                    Afloat Repairs, Offshore Support, Automation Solutions And Industrial Services, Driven by Technical Excellence, 
                    Reliability and a Firm Commitment to World-Class Service Standards.
                  </p>
                </div>
              </motion.div>
            </div>
          </div>
        </section>

        

       

        <LiveChat />
        <QAChatbot />
        <ScrollSocialIcons />
        <GetQuoteButton />
        <BackToTopButton />
        <Footer />
      </div>
    </div>
  );
};

export default About;